import { useModal } from '../../../hooks/useModal'

export function Modal(){
    const { modal, limparModal } = useModal()

    return (
        <>
            <button type="button" data-toggle="modal" data-target="#modal-default" 
                id="abrirModal" style={{display: 'none'}}>Abrir Modal</button>
            <div className="modal fade" data-backdrop="static" id="modal-default">
                <div className={`modal-dialog ${!modal.grande ? !modal.pequeno ? 'modal-lg' : 'modal-md' : 'modal-xl'}`}>
                    <div className="modal-content bg-primary tema-ant-fundo">
                        <div className="modal-header p-2">
                            <h4 className="modal-title">{modal.titulo ?? '-'}</h4>
                            <button type="button" id="btnFecharModal" className="close" data-dismiss="modal" aria-label="Close" onClick={() => limparModal()}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body bg-white">
                            {modal.corpo}
                        </div>
                        {((!modal.escondeBotaoFechar && !modal.escondeBotaoOk) ?
                            <div className="modal-footer justify-content-between bg-white">
                                {((!modal.escondeBotaoFechar) ? 
                                    <button type="button" className="btn btn-default" data-dismiss="modal"
                                        onClick={() => {
                                            if (modal.onClickFechar) {
                                                modal.onClickFechar(modal.parametroFechar);
                                            }
                                            limparModal()
                                        }}>{modal.txtBotaoFechar ?? "Fechar"}</button>
                                        : null)}
                                {((!modal.escondeBotaoOk) ? 
                                    <button type="button" className="btn btn-primary" data-dismiss="modal"
                                    onClick={() => {
                                            if (modal.onClickOk) {
                                                modal.onClickOk(modal.parametroOk)
                                            }
                                            limparModal()
                                        }}>{modal.txtBotaoOk ?? "OK"}</button>
                                : null)}
                            </div>
                        : null)}
                    </div>
                </div>
            </div>
        </>
    )
}